
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/sandbox",
      function () {
        return require("private-next-pages/docs/api/sandbox.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/sandbox"])
      });
    }
  